import React, { useContext } from 'react'
import { toast } from 'react-toastify'
import * as backendAPI from '../api/backend-api'
import SessionContext from '../context/session'
import UserForm from './../components/UserForm'

const handleRegister = (event, username, password, name) => {
  console.log('INFO - Registering users')
  backendAPI
    .register(username, password, name)
    .then(e => {
      toast.success('User registered, please verify your email')
    })
    .catch(e => {
      if (e.error) {
        toast.error(e.error)
      } else {
        console.log(e)
        toast.error('Oops, something went wrong')
      }
    })
  event.preventDefault()
}

const Register = () => {
  const sessionContext = useContext(SessionContext)
  const { user } = sessionContext.state

  if (!user) {
    return (
      <UserForm
        title="Register"
        formType="register"
        handleSubmit={(event, username, password, rpassword, currentpassword, name) => handleRegister(event, username, password, name)}
      ></UserForm>
    )
  } else {
    return (
      <div className="form-container">
        <div className="form-title"> Register </div>
        <div className="form-text">You are logged in, logout first!</div>
      </div>
    )
  }
}

export default Register
